import React, { useState } from "react";
import { connect } from "react-redux";
import Button from "components/button";
import { ArrowRight, CircleCheck, LucideArrowRight, LucideUserPlus, LucideZap } from "lucide-react";
import HeaderModal from "components/modal/HeaderModal";
import EnrolleeDetails from "./EnrolleeDetails";
import {
  doClassParticipantsEnroll
} from '../../../../../redux/trainingclass/trainingClassState'

const steps = [
  { title: "Select Course" },
  { title: "Select Team Members" },
  { title: "Enroll" },
];

const EnrollmentSteps = ({ 
  step1Done,
  step2Done,
  step3Active,
  selectedCourse,
  selectedMembers,
  enrollParticipants,
}) => {
  
  const [isModalOpen, setIsModalOpen] = useState(false);

  const stepStatus = [
    step1Done ? "completed" : !step1Done && !step2Done ? "active" : "inactive",
    step2Done ? "completed" : !step2Done && !step1Done ? "inactive" : !step2Done && step1Done ? "active" : "inactive",
    step3Active ? "active" : "inactive",
  ];

  const handleStepClick = (index) => {
    if (index === 2 && step3Active) {
      setIsModalOpen(true);
    }
  };

  const onClickEnrollParticipants = () => {
    if (!selectedMembers?.length || !selectedCourse?.id) return;

    const recordId = selectedMembers.map(member => ({ tcp_user_id: member.userId }));

    enrollParticipants({
      classeId: selectedCourse.id, 
      recordId: recordId            
    });
  };



    
 return (
    <>
      <div className="stepper-container flex items-center gap-4">
        {steps.map((step, index) => (
          <div key={index} className="step-wrapper flex items-center gap-2">
            <div
              className={`step-box ${stepStatus[index]} cursor-pointer dark:bg-white/10`}
              onClick={() => handleStepClick(index)}
            >
              <div className="step-circle flex items-center justify-center w-6 h-6 rounded-full bg-gray-200 dark:bg-white/30">
                {stepStatus[index] === "completed" ? (
                  <CircleCheck className="w-4 h-4 text-white" />
                ) : (
                  index + 1
                )}
              </div>
              <span className="step-label ml-2 dark:text-white">{step.title}</span>
            </div>

            {index < steps.length - 1 && <ArrowRight size={20} className="text-white"/>}
          </div>
        ))}
      </div>
      <div className="">
        <HeaderModal
          group="gradient-icon"
          open={isModalOpen}              
          onClose={() => setIsModalOpen(false)}
          icon={<LucideZap size={32} className="text-white"/>}
          closable={false}                     
          title={"Ready to Enroll!"}                    
          description={"Review the enrollment details below and confirm to proceed."}             
          colorTheme="gradient-emerald"
          footer={(
              <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end relative m-4">
                <Button 
                  onClick={() => setIsModalOpen(false)} 
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium shrink-0 h-9 bg-white px-4 py-2 border-2 hover:bg-slate-50 hover:shadow-none"
                >
                  Cancel
                </Button>
                <Button 
                  className="btn-gradient-emerald !h-9 flex"
                  onClick={onClickEnrollParticipants}
                >
                  {<div className="flex items-center gap-2">
                      {<LucideUserPlus size={16} className="flex"/>} Confirm Enrollment <LucideArrowRight size={16} className="flex"/>
                  </div>}
                </Button>
              </div>
            )}  
          >
            <EnrolleeDetails
              selectedCourse={selectedCourse}
              selectedMembers={selectedMembers}
            />
        </HeaderModal>
      </div>
        
    </>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  enrollParticipants: (data) => dispatch(doClassParticipantsEnroll(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnrollmentSteps);
